export function deepClone(object) {
    if (object === null) return null;
    let clone = Object.assign({}, object);
    Object.keys(clone).forEach(
        key => (clone[key] = typeof object[key] === 'object' ? deepClone(object[key]) : object[key])
    );
    if (Array.isArray(object)) {
        clone.length = object.length;
        return Array.from(clone);
    }
    return clone;
}
